import React from "react";
import KogInputTextLogin from "@/main/components/shared/inputText/inputTextLogin";
import { useRecoveryPassword } from "@/main/hooks/accountRecoveryHook";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useStyles, ButtonLogin, ButtonToggleScreen } from "../../styles";
import * as S from "./styles";
import { getTranslateByKey } from "@/main/services/utils";
import { KeyValue } from "@/main/models/common";

interface ILoginRecoveryPasswordProps {
	toggleRecoveryPassword: () => void;
	translatesLocal: KeyValue[];
}

export default function LoginRecoveryPassword({
	toggleRecoveryPassword,
	translatesLocal,
}: ILoginRecoveryPasswordProps) {
	const styles = useStyles();
	const formRecoveryPassword = useRecoveryPassword(translatesLocal);

	function handleRecoveryPassword(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		formRecoveryPassword.submit();
	}

	return (
		<S.Container id="recover-password-form" onSubmit={handleRecoveryPassword}>
			<KogInputTextLogin
				autoFocus
				id="txt-recovery-pwd-email"
				className={styles.inputTextCustom}
				variant="outlined"
				label={getTranslateByKey("information.fillInYourUsername", false, translatesLocal)}
				helperText={formRecoveryPassword.errors.usernameResetPassword?.message}
				error={!!formRecoveryPassword.errors.usernameResetPassword || !!formRecoveryPassword.serverErrors}
				{...formRecoveryPassword.register("usernameResetPassword", {
					required: getTranslateByKey("information.usernameRequired", true, translatesLocal),
				})}
				title={getTranslateByKey("information.fillInYourUsername", false, translatesLocal)}
			/>
			<S.ContainerBackButton>
				<ButtonToggleScreen type="button" onClick={toggleRecoveryPassword}>
					{getTranslateByKey("information.backToLogin", false, translatesLocal)}
				</ButtonToggleScreen>
				<ButtonLogin type="submit" disabled={formRecoveryPassword.submitInProgress}>
					{getTranslateByKey("information.send", false, translatesLocal)}
					<ArrowForward fontSize="small" />
				</ButtonLogin>
			</S.ContainerBackButton>
		</S.Container>
	);
}
